import styled from "styled-components"

const DateFilterStyle = styled.div`
  margin: 0 10px 0 12px;
`
export default DateFilterStyle

export const Filter = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) => props.theme.colorbluegreylight};
  padding: 7px 10px;
  border-radius: 35px;
  gap: 6px;
`

export const FilterText = styled.div`
  color: ${(props) => props.theme.textcolordblack};
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
`

export const DateOptionsStyle = styled.div`
  background-color: ${(props) => props.theme.colorbluegreylight};
  border-radius: 8px;
  padding: 4px;
  color: ${(props) => props.theme.textcolordblack};
  ul {
    list-style: none;
    li {
      padding: 10px 15px;
      border-bottom: 1px solid ${(props) => props.theme.colorsharpgrey};
      cursor: pointer;
      &:nth-child(5) {
        color: ${(props) => props.theme.primary};
      }
    }
  }
`
